import { inject, Pipe, PipeTransform } from '@angular/core';
import { LanguageIso, LanguageMapper } from '@mkp/shared/models';
import { getCookieNoticeUrl, getPrivacyNoticeUrl } from '@mkp/shared/util-zendesk';
import { TranslateService } from '@ngx-translate/core';

const urlTypes = ['GTC', 'PP', 'CN'] as const;

const gtcLinks: Record<LanguageIso, string> = {
  'en-CH': 'https://www.jobcloud.ch/c/en/terms/',
  'fr-CH': 'https://www.jobcloud.ch/c/fr-ch/conditions-generales/',
  'de-CH': 'https://www.jobcloud.ch/c/de-ch/agb/',
};

@Pipe({ name: 'gdprLink' })
export class GdprLinkPipe implements PipeTransform {
  translateService = inject(TranslateService);

  transform(text: string): string {
    return urlTypes.reduce(
      (acc, urlType) => acc.replace(`--${urlType}--`, this.makeLink(urlType)),
      text
    );
  }

  private makeLink(urlType: 'GTC' | 'PP' | 'CN'): string {
    const languageIso = this.getLanguageIso();
    return `<a href="${getHref(languageIso, urlType)}" class="gdprLink" target="_blank">`;
  }

  private getLanguageIso(): LanguageIso {
    return (
      (this.translateService.getCurrentLang() as LanguageIso) ||
      (this.translateService.getFallbackLang() as LanguageIso)
    );
  }
}

const getHref = (lang: LanguageIso, urlType: 'PP' | 'GTC' | 'CN'): string => {
  const langCode = LanguageMapper.toCode(lang);
  switch (urlType) {
    case 'PP':
      return getPrivacyNoticeUrl(langCode);
    case 'CN':
      return getCookieNoticeUrl(langCode);
    case 'GTC':
      return gtcLinks[lang];
  }
};
